import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommentsBootstrapModule } from './comments-bootstrap.module';
import { CommentCreatePage } from './pages/create/create.page';
import { CommentEditPage } from './pages/edit/edit.page';
import { CommentIndexPage } from './pages/index/index.page';
import { RouteService } from '@kaiser-software/chassis-core';

@NgModule({
    imports: [ CommentsBootstrapModule ],
    exports: [ RouterModule ]
})
export class CommentsRoutingModule {

    constructor(protected router: RouteService) {
        // Comments
        router.add('comments', CommentIndexPage, 'comments.index', { permission: 'comment.read', layout: 'full-width' });
        router.add('comments/create', CommentCreatePage, 'comments.create', { permission: 'comment.write' });
        router.add('comments/:comment', CommentEditPage, 'comments.show', { permission: 'comment.write' });
        router.add('comments/:comment/edit', CommentEditPage, 'comments.edit', { permission: 'comment.write' });
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/comments-routing.module.ts